import { render } from "./PaymentReceiptPub.vue?vue&type=template&id=1229e413"
import script from "./PaymentReceiptPub.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptPub.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__